import { connectivityService } from './ConnectivityService';

/**
 * Keeps Easy Peasy `app.offline` in sync with ConnectivityService (single source of truth).
 * Call once after the store is created so axios can update connectivity before React mounts.
 */
export function registerConnectivityStoreBridge(updateProjection: () => void): void {
  connectivityService.subscribe(() => {
    updateProjection();
  });
}
